import { API_PURCHASE_TIMER } from 'utils/constants'
import Api from './axiosInstance'

type FetchPurchaseTimersParams = {
  limit: number
  page: number
  search?: string
  filters?: any
}

type CreatePurchaseTimerPayload = {
  barcode: string
  store: string
  availableToPurchaseTimer: boolean
  purchaseStartTime: string
  purchaseEndTime: string
}

type UpdatePurchaseTimerPayload = {
  availableToPurchaseTimer?: boolean
  purchaseStartTime?: string
  purchaseEndTime?: string
}

export const fetchPurchaseTimers = ({
  limit,
  page,
  search,
  filters,
}: FetchPurchaseTimersParams) => {
  let options: any = {}

  if (search) {
    options.search = search
  }

  if (filters) {
    options = { ...options, ...filters }
  }

  const params = new URLSearchParams({
    limit,
    page,
    ...options,
  })

  return Api.get({
    url: `${API_PURCHASE_TIMER.PURCHASE_TIMER}?${params}`,
  })
}

export const fetchPurchaseTimerById = (id: string) => {
  return Api.get({
    url: `${API_PURCHASE_TIMER.PURCHASE_TIMER}/${id}`,
  })
}

export const createPurchaseTimer = (data: CreatePurchaseTimerPayload) => {
  return Api.post({
    url: API_PURCHASE_TIMER.PURCHASE_TIMER,
    data,
  })
}

export const updatePurchaseTimer = (
  id: string,
  data: UpdatePurchaseTimerPayload,
) => {
  return Api.patch({
    url: `${API_PURCHASE_TIMER.PURCHASE_TIMER}/${id}`,
    data,
  })
}

export const deletePurchaseTimer = (id: string) => {
  return Api.delete({
    url: `${API_PURCHASE_TIMER.PURCHASE_TIMER}/${id}`,
  })
}

export const exportPurchaseTimerData = () => {
  return Api.post({
    url: API_PURCHASE_TIMER.EXPORT,
  })
}

export const importPurchaseTimerData = async (data: any) => {
  return Api.post({
    url: API_PURCHASE_TIMER.IMPORT,
    data,
    headers: { 'Content-Type': 'multipart/form-data' },
  })
}
